import { RootState, useAppDispatch, useAppSelector } from '../../store/store';
import { useTranslation } from 'react-i18next';
import FailedDynamicDialog from '../common/FailedDynamicDialog';
import { memo } from 'react';
import { handleToggleFailedOptimizationModal } from '../../store/optimization-slice/optimization';

const FailedOptimizationDialog = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { failedOptimizationDialog } = useAppSelector((state: RootState) => state.optimization);

    return (
        <FailedDynamicDialog 
            isOpen={failedOptimizationDialog?.isOpen} 
            title={t('ERROR_DIALOG_TITLE')} 
            content={failedOptimizationDialog?.body?.message} 
            subContent={failedOptimizationDialog?.body?.description}
            onClose={function (): void {
                dispatch(handleToggleFailedOptimizationModal({ isOpen: false, body: null }));
            }} 
        />
    );
};

export default memo(FailedOptimizationDialog);